import React, { useState, useContext } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import logo from "./logo-ipm.png";
import style from "./Navbar.module.css";
import UserContext from "../../store/user-context";
import { Icon } from "@iconify/react";
const Navbar = (props) => {
  const userContext = useContext(UserContext);
  const history = useHistory();
  const [color, setColor] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const { search } = useLocation();
  const queryParam = new URLSearchParams(search);
  const cari = queryParam.get("cari");

  // const [cari, setCari] = useState("");

  const logout = () => {
    userContext.logoutHandler();
  };

  const changecolor = () => {
    if (window.scrollY >= 300) {
      setColor(true);
    } else {
      setColor(false);
    }
  };

  window.addEventListener("scroll", changecolor);
  return (
    <nav
      style={props.style}
      className={`navbar fixed-top navbar-expand-sm navbar-dark 
      ${!props.otherPage && (color ? style.navbar : style.navbar_transparant)}
      ${props.otherPage && style.navbar}`}
    >
      <div className="container-fluid">
        <Link to="/" className={`navbar-brand ${style.logo}`}>
          <img src={logo} alt="pd ipm karawang header"></img>
          PD IPM Karawang
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className={`collapse navbar-collapse ${style.collapse}`}
          id="navbarSupportedContent"
        >
          {!props.otherPage && (
            <form className={style.input_cari}>
              <input
                className="form-control"
                type="search"
                placeholder="Search"
                aria-label="Search"
                // onClick={() => {
                //   history.push("/search");
                // }}
                value={cari ? cari : ""}
                onChange={(e) => history.push("/search?cari=" + e.target.value)}
              />
            </form>
          )}
          <div className={style.container_button_login}>
            {userContext.login == false && (
              <div className={style.login}>
                <Link
                  to="/login"
                  className={`${style.button_not_login} ${style.list_item}`}
                >
                  Login
                </Link>
              </div>
            )}

            {userContext.login == true && userContext.loading == false && (
              <div className={style.login}>
                <Link
                  to="#"
                  className={`${style.button_login} ${style.list_item}`}
                  onClick={() => setOpenModal((e) => !e)}
                >
                  <Icon icon="bxs:user" /> {userContext.user.nama}
                </Link>
                <div>
                  {openModal == true && (
                    <ul className={style.dropdown}>
                      {/* <li className={style.list_dropdown}>
                        <Link to="/profil">Profil</Link>
                      </li> */}
                      <li className={style.list_dropdown}>
                        <Link to="/create-post">Buat Post</Link>
                      </li>
                      <li className={style.list_dropdown} onClick={logout}>
                        Logout
                      </li>
                    </ul>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
